// extracted by mini-css-extract-plugin
export default {"listItem":"style_listItem__k6urN","title":"style_title__HJn1Z","image":"style_image__On2WB","subTitle":"style_subTitle__Wh+xW"};